module.exports = __webpack_public_path__ + "img/ark.443086c0.svg";